export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_STATUS = 'SET_STATUS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_SERVICE_REQUEST = 'SET_SERVICE_REQUEST'
export const SET_SERVICE_REQUESTS = 'SET_SERVICE_REQUESTS'
export const SET_SERVICE_REQUEST_HISTORY = 'SET_SERVICE_REQUEST_HISTORY'
export const SET_SERVICE_REQUEST_ISSUES = 'SET_SERVICE_REQUEST_ISSUES'



// WEBPACK FOOTER //
// ./src/store/modules/servicerequests/types.js